import React, { useState, useRef, useEffect } from "react";
import { MdPhotoCamera } from "react-icons/md";
import Navbar from "../../Navbar/navbar";
import axios from "axios";
import { baseUrl } from "../../../Environments/environment";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import { useParams, useNavigate } from "react-router-dom";

const IdProofUpload = () => {
  const navigate = useNavigate();
  const guestid = useParams();
  const guestSessionId = guestid.id;

  const fileInputRef = useRef(null);
  const [idProof, setIdProof] = useState(null);
  const [idProofError, setIdProofError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [guest, setGuest] = useState(null);
  const [propertyId, setPropertyId] = useState(null);

  const getGuest = async () => {
    try {
      console.warn("GUEST SESSION ID->", guestSessionId);
      const response = await axios.get(
        `${baseUrl}/guestApi/${guestSessionId}/guest`,
      );
      console.warn(response.data);
      setGuest(response.data.result);
      setPropertyId(response.data.result.propertyId);
    } catch (error) {
      console.error("Error fetching guest data:", error);
    }
  };

  useEffect(() => {
    //console.warn("USE EFFECT")
    getGuest();
  }, []);

  const handleIconClick = () => {
    fileInputRef.current?.click();
  };

  const handleImageChange = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      setIdProofError(false);
      setIdProof(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!idProof) {
      setIdProofError(true);
      toast.error("Photo ID proof is required");
      return;
    }

    setIsSubmitting(true);
    setIdProofError(false);

    try {
      const formData = new FormData();
      formData.append("guestIdProof", idProof);

      await axios.post(
        `${baseUrl}/guestApi/${guestSessionId}/id-proof`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      toast.success("ID proof uploaded successfully");
      setIdProof(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

      setTimeout(() => {
        navigate(`/${guestSessionId}`);
      }, 500);
    } catch (error) {
      const errorMessage =
        error.response?.data?.error?.guestIdProof?.[0] ||
        error.response?.data?.message ||
        "Failed to upload ID proof";
      toast.error(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Navbar />
      <ToastContainer />
      <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md mx-auto">
          <div className="bg-white shadow rounded-lg p-6">
            <h2 className="text-xl font-bold text-gray-800 mb-6">
              ID Verification
            </h2>

            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="flex justify-start text-gray-700 text-sm font-bold mb-2">
                  ID Verification *
                </label>
                <div className="text-gray-900 text-sm font-semibold font-poppins mb-2 flex justify-start break-words items-start">
                  Please take a photo of your driver's license or government
                  issued ID
                </div>
                {idProof && (
                  <div className="text-black text-sm font-poppins mb-4 flex justify-start break-words items-start">
                    (To select different image,{" "}
                    <span
                      onClick={handleIconClick}
                      className="underline cursor-pointer text-indigo-600"
                    >
                      click here
                    </span>
                    )
                  </div>
                )}
                <div
                  className="border border-gray-400 p-6 rounded-md flex flex-col items-center justify-center mb-4 cursor-pointer"
                  onClick={handleIconClick}
                >
                  <div className="w-full h-full flex items-center justify-center rounded-full mb-2">
                    <MdPhotoCamera
                      className={`w-14 h-14 ${idProof ? "hidden" : ""}`}
                    />
                    <input
                      type="file"
                      accept="image/*"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      onChange={handleImageChange}
                    />
                    {idProof && (
                      <div className="mt-4">
                        <img
                          src={URL.createObjectURL(idProof)}
                          alt="Selected"
                          className="object-cover max-w-full max-h-32"
                        />
                      </div>
                    )}
                  </div>
                  <div
                    className={`text-gray-900 font-semibold font-poppins text-center text-xs mt-4 ${
                      idProof ? "hidden" : ""
                    }`}
                  >
                    We will not have access to ID in this system after your stay
                    concludes
                  </div>
                </div>
                {idProofError && (
                  <p className="text-red-600 text-sm text-left">
                    Photo ID proof is required
                  </p>
                )}
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-indigo-600 hover:bg-indigo-700 disabled:bg-indigo-400 text-white font-semibold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 flex items-center justify-center min-h-[44px]"
              >
                {isSubmitting ? <LoadingSpinner /> : "Submit ID Proof"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default IdProofUpload;
